import React from 'react';

// @mui
import { TableCell } from '@mui/material';

export default class GridNumberCell extends React.Component {
    render() {
        const baseStyle = this.props.styles;

        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                {this.props.value || 0}
            </TableCell>
        );
    }
}
